export default __webpack_public_path__ + "static/media/6.65fc3210.png";